"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));

// copied from aem repo
var screenSizes = {
  isMobile: function isMobile() {
    return window.matchMedia ? window.matchMedia('(max-width: 650px)').matches : false;
  },
  isTabletAndUnder: function isTabletAndUnder() {
    return window.matchMedia ? window.matchMedia('(max-width: 1200px)').matches : false;
  },
  isTabletAndOver: function isTabletAndOver() {
    return window.matchMedia ? window.matchMedia('(min-width: 651px)').matches : false;
  },
  isTablet: function isTablet() {
    return window.matchMedia ? window.matchMedia('(min-width: 651px) and (max-width: 1200px)').matches : false;
  },
  isDesktop: function isDesktop() {
    return window.matchMedia ? window.matchMedia('(min-width: 1201px)').matches : false;
  }
};
var _default = screenSizes;
exports.default = _default;
module.exports = exports["default"];